import React from "react";
import { USDollar, toNumber } from "./utils";

const money = (value) =>
  value === null || value === undefined ? "-" : USDollar.format(toNumber(value));

const negativeMoney = (value) =>
  toNumber(value) ? `(${USDollar.format(toNumber(value))})` : "-";

export default function AgingTable({ period, onDrill }) {
  const aging = period?.aging || [];
  const totals = period?.totals || {};

  return (
    <div className="w-full border rounded-lg overflow-hidden">
      <div className="bg-gray-100 border-b p-3">
        <h2 className="text-sm font-bold">Delinquency Aging Report</h2>
        <p className="text-xs font-extralight text-gray-500">
          Open balance by days overdue — reference date{" "}
          {period?.reference_date || "-"}
        </p>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full border-collapse text-xs">
          <thead>
            <tr className="bg-gray-50 border-b">
              <th className="text-left p-3 font-semibold text-gray-700">Aging</th>
              <th className="text-right p-3 font-semibold text-gray-700">
                Amount
              </th>
              <th className="text-right p-3 font-semibold text-gray-700">
                Discount
              </th>
              <th className="text-right p-3 font-semibold text-gray-700">Paid</th>
              <th className="text-right p-3 font-semibold text-gray-700">
                Fee (as of today)
              </th>
              <th className="text-right p-3 font-semibold text-gray-700">
                Balance
              </th>
              <th className="text-right p-3 font-semibold text-gray-700">%</th>
              <th className="text-right p-3 font-semibold text-gray-700">
                # Students
              </th>
              <th className="text-right p-3 font-semibold text-gray-700">
                # Invoices
              </th>
            </tr>
          </thead>
          <tbody>
            {aging.map((range, index) => (
              <tr
                key={range.key}
                onClick={() =>
                  toNumber(range.sum) > 0 &&
                  onDrill({
                    reference_date: period.reference_date,
                    aging_key: range.key,
                    title: range.label,
                  })
                }
                className={`border-b transition-colors ${
                  index % 2 === 0 ? "bg-white" : "bg-gray-50"
                } ${
                  toNumber(range.sum) > 0
                    ? "cursor-pointer hover:bg-green-50"
                    : "text-gray-400"
                }`}
              >
                <td className="p-3 font-medium text-left">{range.label}</td>
                <td className="p-3 text-right">{money(range.amount)}</td>
                <td className="p-3 text-right text-red-600">
                  {negativeMoney(range.discount)}
                </td>
                <td className="p-3 text-right">{money(range.paid)}</td>
                <td className="p-3 text-right">
                  {toNumber(range.fee)
                    ? USDollar.format(toNumber(range.fee))
                    : "-"}
                </td>
                <td className="p-3 text-right font-semibold">
                  {USDollar.format(toNumber(range.sum))}
                </td>
                <td className="p-3 text-right">
                  {toNumber(range.percent).toFixed(2)}%
                </td>
                <td className="p-3 text-right">{toNumber(range.students)}</td>
                <td className="p-3 text-right">{toNumber(range.invoices)}</td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr
              onClick={() =>
                toNumber(totals.sum) > 0 &&
                onDrill({
                  reference_date: period.reference_date,
                  title: "All aging ranges",
                })
              }
              className={`bg-gray-100 border-t-2 border-gray-300 font-bold ${
                toNumber(totals.sum) > 0
                  ? "cursor-pointer hover:bg-green-50"
                  : ""
              }`}
            >
              <td className="p-3 text-left">Total</td>
              <td className="p-3 text-right">{money(totals.amount)}</td>
              <td className="p-3 text-right text-red-600">
                {negativeMoney(totals.discount)}
              </td>
              <td className="p-3 text-right">{money(totals.paid)}</td>
              <td className="p-3 text-right">
                {toNumber(totals.fee) ? USDollar.format(toNumber(totals.fee)) : "-"}
              </td>
              <td className="p-3 text-right">
                {USDollar.format(toNumber(totals.sum))}
              </td>
              <td className="p-3 text-right">
                {toNumber(totals.percent).toFixed(2)}%
              </td>
              <td className="p-3 text-right">{toNumber(totals.students)}</td>
              <td className="p-3 text-right">{toNumber(totals.invoices)}</td>
            </tr>
          </tfoot>
        </table>
      </div>

      <div className="p-2 px-3 text-[11px] text-gray-500 border-t bg-white">
        Columns follow the same order as the drill-down totals (Amount →
        Discount → Paid → Fee → Balance), so the line you click matches the
        modal footer. # Students on the total line counts each student once, so
        it is not the sum of the ranges.
      </div>
    </div>
  );
}
